/* eslint react-hooks/exhaustive-deps: "warn" */
import { type ReactNode, Fragment } from 'react';

import { Section } from 'ui/molecules/Section/Section';

import styles from './CompareNarrative.module.scss';

type Props = {
  id?: string;
  title: ReactNode;
  description?: ReactNode;
  paragraphs: ReactNode[];
  pull?: ReactNode;
  background?: string;
};

export const CompareNarrative = ({ id, title, description, paragraphs, pull, background }: Props) => {
  // Pull quote sits between the body paragraphs, before the closing one.
  const pullAfter = pull ? Math.max(0, paragraphs.length - 2) : -1;

  return (
    <Section
      id={id}
      background={background}
      layout="split"
      splitAlign="top"
      splitSticky
      title={title}
      description={description}
      className={styles.section}
      introBlockClassName={styles.intro}
    >
      <div className={styles.body}>
        {paragraphs.map((paragraph, i) => (
          <Fragment key={i}>
            <p className={styles.paragraph}>{paragraph}</p>
            {i === pullAfter && <blockquote className={styles.pull}>{pull}</blockquote>}
          </Fragment>
        ))}
      </div>
    </Section>
  );
};
